import type { ReactNode } from "react";
import { cx } from "../cx.js";
import styles from "./Table.module.css";

export interface Column<T> {
  key: string;
  header: ReactNode;
  cell: (row: T) => ReactNode;
  /** Zahlen/Aktionen am Zeilenende */
  align?: "start" | "end";
  width?: string;
}

/** Schlichte, semantische Tabelle (Screenreader-freundlich), scrollt horizontal statt zu brechen. */
export function DataTable<T>({
  caption,
  columns,
  rows,
  rowKey,
  empty,
}: {
  caption: string;
  columns: Column<T>[];
  rows: T[];
  rowKey: (r: T) => string;
  empty?: ReactNode;
}) {
  if (!rows.length && empty) return <>{empty}</>;
  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <caption className="omony-visually-hidden">{caption}</caption>
        <thead>
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                scope="col"
                className={cx(c.align === "end" && styles.end)}
                style={c.width ? { inlineSize: c.width } : undefined}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={rowKey(r)}>
              {columns.map((c) => (
                <td key={c.key} className={cx(c.align === "end" && styles.end)}>
                  {c.cell(r)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
